import { CaretUp } from '@phosphor-icons/react';

export default CaretUp;
